export enum RequestTypes {
    Requester = 0,
    Approver,
    FinalApprover
}

export const requestTypesURLRoutes = ['request', 'approve', 'confirm'];
